import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Table, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SubServices = () => {
    const [subServices, setSubServices] = useState([]);
    const [mainServices, setMainServices] = useState([]);
    const [mainServicesMap, setMainServicesMap] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("add");
    const [formData, setFormData] = useState({
        main_service_id: "",
        title: "",
        sub_title: "",
        desc: "",
        image: null,
        client_image: null,
        link: "",
        date: "",
        id: null,
    });

    const baseUrl = "https://api.glyphqai.com";

    useEffect(() => {
        fetchServices();
    }, []);

    const fetchServices = async () => {
        try {
            const [subRes, mainRes] = await Promise.all([
                axios.get(`${baseUrl}/api/get-subservice`),
                axios.get(`${baseUrl}/api/get-mainservice`)
            ]);
            if (subRes.data.status === 200) {
                setSubServices(subRes.data.sub_services);
            }
            if (mainRes.data.status === 200) {
                setMainServices(mainRes.data.main_services);
                const map = {};
                mainRes.data.main_services.forEach(service => {
                    map[service.id] = service.title;
                });
                setMainServicesMap(map);
            }
        } catch (error) {
            console.error("Error fetching services:", error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData((prev) => ({ ...prev, [e.target.name]: e.target.files[0] }));
    };

    const handleOpenModal = (type, service = null) => {
        setModalType(type);
        setFormData({
            main_service_id: service?.main_service_id || "",
            title: service?.title || "",
            sub_title: service?.sub_title || "",
            desc: service?.desc || "",
            image: null,
            client_image: null,
            link: service?.link || "",
            date: service?.date || "",
            id: service?.id || null,
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const isAddMode = modalType === "add";
        let requestData;

        const formPayload = new FormData();
        Object.keys(formData).forEach((key) => {
            if (formData[key] !== null) {
                formPayload.append(key, formData[key]);
            }
        });
        requestData = formPayload;
        if (!isAddMode) {
            requestData.append("_method", "PUT")
        } 

        const apiUrl = isAddMode
            ? `${baseUrl}/api/store-subservice`
            : `${baseUrl}/api/update-subservice/${formData.id}`;

        axios({
            method: "post" ,
            url: apiUrl,
            data: requestData,
            // headers: isAddMode
            //     ? { "Content-Type": "multipart/form-data" }
            //     : { "Content-Type": "application/json" },
        })
            .then(() => {
                toast.success(`Sub-service ${isAddMode ? "added" : "updated"} successfully!`);
                fetchServices();
                handleCloseModal();
            })
            .catch((error) => {
                console.error(`Error ${isAddMode ? "adding" : "updating"} sub-service:`, error);
                toast.error("Operation failed.");
            });
    };

    const handleDelete = (id) => {
        axios.delete(`${baseUrl}/api/deletesubservice/${id}`)
            .then(() => {
                setSubServices(prev => prev.filter((service) => service.id !== id));
                toast.success("Sub-service deleted successfully!");
            })
            .catch((error) => {
                console.error("Error deleting sub-service:", error);
                toast.error("Failed to delete sub-service.");
            });
    };

    const uniqueSubServices = Array.from(
        mainServices.reduce((map, service) => {
            if (!map.has(service.service_id)) {
                map.set(service.service_id, service);
            }
            return map;
        }, new Map()).values()
    );
    return (
        <>
            <div className="container">
                <div className="my-3 mt-5 d-flex justify-content-between">
                    <h2 className="font-bold display-5">Sub Services</h2>
                    <Button onClick={() => handleOpenModal("add")}>Add Sub Service</Button>
                </div>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th className="text-center">#</th>
                            <th>Main Service</th>
                            <th>Title</th>
                            <th>Subtitle</th>
                            <th>Description</th>
                            <th>Link</th>
                            <th>Date</th>
                            <th>Image</th>
                            <th>Client Image</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {subServices.map((service, index) => (
                            <tr key={service.id}>
                                <td className="text-center">{index + 1}</td>
                                <td>{mainServicesMap[service.main_service_id]}</td>
                                <td>{service.title}</td>
                                <td>{service.sub_title}</td>
                                <td>{service.desc}</td>
                                <td>{service.link ? <a href={service.link} target="_blank" rel="noopener noreferrer">View Link</a> : "N/A"}</td>
                                <td>{service.date}</td>
                                <td>
                                    <img
                                        src={`${baseUrl}/uploads/subservices/${service.image}`}
                                        alt={service.title}
                                        style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                    />
                                </td>
                                <td>
                                    <img
                                        src={`${baseUrl}/uploads/subservices/${service.client_image}`}
                                        alt="Client"
                                        style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                    />
                                </td>
                                <td>
                                    <Button onClick={() => handleOpenModal("edit", service)}>Edit</Button>
                                    <Button variant="danger" onClick={() => handleDelete(service.id)}>Delete</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === "add" ? "Add Sub Service" : "Edit Sub Service"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mt-0">
                            <Form.Label>Main Service</Form.Label>
                            <Form.Select
                                name="main_service_id"
                                value={formData.main_service_id}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="">Select a main service</option>
                                {uniqueSubServices.map((service) => (
                                    <option key={service.id} value={service.id}>
                                        {service.title}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formTitle" className="mt-3">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter title"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formSubTitle" className="mt-3">
                            <Form.Label>Subtitle</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter subtitle"
                                name="sub_title"
                                value={formData.sub_title}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formDesc" className="mt-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Enter description"
                                name="desc"
                                value={formData.desc}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formLink" className="mt-3">
                            <Form.Label>Link</Form.Label>
                            <Form.Control
                                type="url"
                                placeholder="Enter link"
                                name="link"
                                value={formData.link}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group controlId="formDate" className="mt-3">
                            <Form.Label>Date</Form.Label>
                            <Form.Control
                                type="date"
                                name="date"
                                value={formData.date}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        {true &&  
                            <>
                                <Form.Group controlId="formImage" className="mt-3">
                                    <Form.Label>Image</Form.Label>
                                    <Form.Control
                                        type="file"
                                        name="image"
                                        onChange={handleFileChange}
                                        required={modalType === "add"}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formClientImage" className="mt-3">
                                    <Form.Label>Client Image</Form.Label>
                                    <Form.Control
                                        type="file"
                                        name="client_image"
                                        onChange={handleFileChange}
                                    />
                                </Form.Group>
                            </>
                        }
                        <Button type="submit" className="mt-3">{modalType === "add" ? "Add Sub Service" : "Update Sub Service"}</Button>
                    </Form>
                </Modal.Body>
            </Modal>


            <ToastContainer />
        </>
    );
};

export default SubServices;
